import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IVendorModel from "../models/IVendorModel";
import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrlWithQuery, buildAuthHeadersForFetch } from "./RestService";
import IOnGetCatalogsDTO from "../models/DTO/IOnGetCatalogsDTO";
import CurrenciesEnum from "@models/CurrenciesEnum";

const getCatalogs = async (userModel: IUserUI, supplierModel: ISupplierModel, vendorModel?: IVendorModel): Promise<IOnGetCatalogsDTO> => {
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.CatalogsGetCatalogs,
    });

    const headers = buildAuthHeadersForFetch({
        userModel,
        supplierModel,
        vendorModel,
    });

    const response = await fetch(url, {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch catalogs: ${response.statusText}`);
    }

    return (await response.json()) as IOnGetCatalogsDTO;
};

const getCurrencyNameFromId = (currencyId: number): string => {
    const currency = CurrenciesEnum[currencyId];
    return currency;
};

const getCurrencyFromId = (currencyId: number): string => {
    const currency = CurrenciesEnum[currencyId];

    console.log("currency: ", currency);

    switch (currency) {
        case "USD":
            return "$";
        case "EUR":
            return "€";
        case "GBP":
            return "£";
        case "CAD":
            return "C$";
        case "AUD":
            return "A$";
        case "JPY":
            return "¥";
        case "MXN":
            return "MXN$";
        case "COP":
            return "COL$";
        default:
            return "$";
    }
};

const CatalogService = {
    getCatalogs,
    getCurrencyFromId,
    getCurrencyNameFromId,
};

export default CatalogService;
